import React from 'react';
import { IPaymentMethod, ISepaInfo, ITypePersonalDataFields, PaymentMethods, Variants } from '@adac-mp/shared';
import { MastercardIcon, PayPalIcon, SEPA, VisaIcon } from '../../Icons';
import { HintMessage, IbanInput, RadioButtons, Typography, getHintContent } from '../../index';

interface IPaymentSelectionProps {
	value?: PaymentMethods;
	paymentMethods: IPaymentMethod[];
	validateFields?: boolean;
	variant?: Variants;
	showHint?: boolean;
	labels?: ITypePersonalDataFields;
	setValue: (value) => void;
	setSepaInfoFilled?: (sepaInfoFilles: boolean) => void;
	updateSepaInfo?: (sepaInfo: ISepaInfo) => void;
}

const paymentMethodIcons = (isSelected) => ({
	1: <PayPalIcon className={isSelected ? '' : 'mix-blend-luminosity'} />,
	2: (
		<span>
			<MastercardIcon className={`inline align-middle ${isSelected ? '' : 'mix-blend-luminosity'}`} />
			<VisaIcon className={`inline ml-1.5 ${isSelected ? '' : 'mix-blend-luminosity'}`} />
		</span>
	),

	3: <SEPA className={isSelected ? '' : 'mix-blend-luminosity'} />,
});

export const PaymentSelection = ({
	paymentMethods,
	value,
	validateFields,
	showHint,
	labels,
	variant,
	setValue,
	setSepaInfoFilled,
	updateSepaInfo,
}: IPaymentSelectionProps) => {
	const renderOptionLabel = (isSelected: boolean, name: string, paymentIcon: JSX.Element) => (
		<span className="pr-4 flex items-center justify-between">
			<Typography variant="title" color={isSelected ? 'title' : 'lightText'} size="lg">
				{name}
			</Typography>
			{paymentIcon}
		</span>
	);

	const paymentMethodOptions = paymentMethods.map(({ id, name }) => {
		const isSelected = String(id) === String(value);
		return {
			id: String(id),
			label: renderOptionLabel(isSelected, name, paymentMethodIcons(isSelected)[id]),
			title: name,
		};
	});

	return (
		<>
			<div className="bg-white rounded">
				<RadioButtons
					data-cy="payment-method"
					className="flex flex-row items-center pl-4 py-[10px] md:py-[14px] border-solid border-t-0 border-l-0 border-r-0 border-b border-b-gray-600 last:border-b-0 last:rounded-b"
					labelClassName="w-full"
					value={String(value)}
					options={paymentMethodOptions}
					setValue={setValue}
				/>
			</div>
			{value === '3' && (
				<IbanInput
					isDkv={variant === 'dkv'}
					validateFields={validateFields}
					updateSepaInfo={updateSepaInfo}
					setSepaInfoFilled={setSepaInfoFilled}
				/>
			)}
			{value !== '3' && showHint && (
				<HintMessage
					className="mt-4"
					hints={getHintContent(
						value === '1' ? 'paypalFlexHint' : 'creditCardFlexHintt',
						[
							{
								tip: 'Hinweis:',
								message:
									'Im Rahmen der pre-Authorisierung wird ein Betrag von 0,10 € auf Ihrer Kreditkarte reserviert. Es erfolgt keine tatsächliche Belastung Ihrer Kreditkarte.',
							},
						],
						labels?.hints,
					)}
				/>
			)}
		</>
	);
};
